import styles from "./NewBadge.module.css";

export default function NewBadge({ label = "NEW" }) {
  return <span className={styles.badge}>{label}</span>;
}
